<template>
  <div class="night-rate-fields">
    <h5 class="pcs-form-section">{{ _('Rate') }}</h5>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label>{{ _('Rate') }}</label>
          <div class="input-group">
            <input type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" v-model="form.rate" :placeholder="placeholder('rate')" />
            <span class="input-group-addon">{{ currency }}</span>
          </div>
          <p class="help-block" v-if="help('rate')">{{ help('rate') }}</p>
        </div>
      </div>
    </div>
    <slot name="after-rate"></slot>
    <h5 class="pcs-form-section">{{ _('Stay limits') }}</h5>
    <div class="row">
      <div class="col-sm-6" v-for="field in stayFields" :key="'sf-' + field.name">
        <div class="form-group">
          <label :title="field.help">{{ field.label }}</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" v-model="form[field.name]" :placeholder="placeholder(field.name)" />
            <span class="input-group-addon">{{ _('days') }}</span>
            <span class="input-group-btn">
              <button type="button" class="btn btn-default" :title="_('No limit')" v-on:click="form[field.name] = '0'">{{ _('Clear') }}</button>
            </span>
          </div>
          <p class="help-block" v-if="help(field.name)">{{ help(field.name) }}</p>
        </div>
      </div>
    </div>
    <h5 class="pcs-form-section">{{ _('Availability') }}</h5>
    <div class="row">
      <div class="col-sm-6" v-for="flag in flagFields" :key="'ff-' + flag.name">
        <div class="form-group">
          <label :title="flag.help">{{ flag.label }}</label>
          <select class="form-control" v-model="form[flag.name]">
            <option value="">{{ emptyLabel(flag.name) }}</option>
            <option value="0">{{ flag.off }}</option>
            <option value="1">{{ flag.on }}</option>
          </select>
          <p class="help-block" v-if="help(flag.name)">{{ help(flag.name) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formats from '~/lib/formats'

// The rate and restriction fields of the price calendar's dialogs (the date dialog and the weekly
// dialog): form { rate, min_stay_arrival, min_stay_through, max_stay, stop_sell,
// closed_to_arrival, closed_to_departure } is edited in place; flags are '' / '0' / '1'.
export default {
  mixins: [formats],
  props: {
    form: { type: Object, required: true },
    currency: { type: String, default: '' },
    placeholder: { type: Function, default: () => '' },
    help: { type: Function, default: () => '' },
    emptyLabel: { type: Function, default: () => '' }
  },
  computed: {
    stayFields () {
      return [
        { name: 'min_stay_arrival', label: this._('Min stay on arrival'), help: this._('Minimum stay required when the stay starts on this day.') },
        { name: 'min_stay_through', label: this._('Min stay through'), help: this._('Minimum stay required if the stay includes this day.') },
        { name: 'max_stay', label: this._('Max stay'), help: this._('Maximum stay allowed when the stay starts on this day.') }
      ]
    },
    flagFields () {
      return [
        { name: 'stop_sell', label: this._('For sale'), help: this._('Stop sales means this day cannot be booked.'), off: this._('On sale'), on: this._('Stop sales') },
        { name: 'closed_to_arrival', label: this._('Check-in'), help: this._('Blocked means guests cannot check in on this day.'), off: this._('Allowed'), on: this._('Blocked') },
        { name: 'closed_to_departure', label: this._('Check-out'), help: this._('Blocked means guests cannot check out on this day.'), off: this._('Allowed'), on: this._('Blocked') }
      ]
    }
  }
}
</script>
